<template>
  <n-scroll>
    <div class="vp-report-wrap" :style="style">
      <list-item v-for="(item, index) in list" :key="index" v-bind="item" />
      <list-item>
        <template #row>
          <div :style="{ marginBottom: calc(20) }">检测结果</div>
          <div
            class="item-row"
            v-for="(e, i) in result"
            :key="`res-${i}`"
            :style="{ marginBottom: calc(12) }"
          >
            <span>{{ e.name }}</span>
            <span class="detail">查看详情</span>
          </div>
        </template>
      </list-item>
      <list-item>
        <template #row>
          <div :style="{ marginBottom: calc(20) }">光谱图</div>
          <div
            :style="{
              width: calc(660),
              height: calc(360),
              background: '#363532',
              borderRadius: '6px'
            }"
          >
            <v-chart class="echart-box" :options="option" :autoresize="true"></v-chart>
          </div>
        </template>
      </list-item>
      <list-item
        label="检测地点"
        value="北京市顺义区吉祥庄村南大街"
        :has-border="false"
      ></list-item>
    </div>
  </n-scroll>
</template>

<script>
import NScroll from '../../components/NScroll';
import ListItem from '../../components/ListItem';
import { formatTimestamp } from '@/utils/utils';
import { option } from './utils/index';

export default {
  name: 'detectionReport',
  components: {
    ListItem,
    NScroll
  },
  inject: ['calc'],
  computed: {
    style() {
      return {
        padding: `0 ${this.calc(30)}`
      };
    }
  },
  data() {
    return {
      list: [
        { label: '检测编号', value: '15' },
        { label: '检测时间', value: formatTimestamp(1593655309000) }
      ],
      result: [{ name: '聚苯乙烯' }, { name: '甲烷' }],
      option: option
    };
  }
};
</script>

<style lang="scss" scoped>
.vp-report-wrap {
  .vp-list-item-wrap {
    .detail {
      color: #7cb3ff;
      cursor: pointer;
    }
  }
}
</style>
